import { Component, OnInit, Input, OnChanges, SimpleChanges, OnDestroy, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { Observable, timer, Unsubscribable } from 'rxjs';
// import { DnSliderService } from './dn-slider.service';

export interface SliderItem {
  index: number;
  image: string;
  thumbname?: string;
  title: string;
  link: string;
  external: boolean;
  query: any;
  color: string;
  loaded: boolean;
}

@Component({
  selector: 'div.sliders',
  templateUrl: './dn-slider.component.html',
  styleUrls: ['./dn-slider.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class DnSliderComponent implements OnInit, OnChanges, OnDestroy {


  @Input()
  items: Array<SliderItem> = [];

  @Input()
  navigator: 'sidebar' | 'thumbnail' | 'indicator' = 'sidebar';


  private subscriptions: Array<Unsubscribable> = [];
  private stop = false;
  private _index = 0;
  get index(): number {
    return this._index;
  }
  set index(value: number) {

    let lastIndex = this._index;
    this._index = value;
    let next = value + 1;
    if (this.items.length > value) {
      this.items[value].loaded = true;
    }
    if (this.items.length > next) {
      this.items[next].loaded = true;
    }
    //this.lastBackground = this.items.length>0?this.items[lastIndex].image:"";
  }

  constructor(
    private _cd: ChangeDetectorRef
  ) {
  }
  ngOnDestroy(): void {
    this.subscriptions.forEach(p => p.unsubscribe());
  }

  ngOnInit(): void {
    this.index = 0;
    this.autoTimer();
     
  }
  private autoTimer()
  {
    this.subscriptions.forEach(p => p.unsubscribe());
    this.subscriptions.push(timer(8000, 8000).subscribe(() => {
      this.next();
    }
  ));
  }
  lastBackground = "";
  private next() {
    if (this.stop) {
      return;
    }

    if (!this.items) {
      return;
    }

    let index = this.index + 1;
    if (index >= this.items.length) {
      index = 0;
    }
    //console.log(index,this.items.length)
    this.index = index;
    this._cd.detectChanges();

  }
  private previous() {
    if (this.stop) {
      return;
    }
    if (!this.items) {
      return;
    }

    let index = this.index - 1;
    if (index < 0) {
      index = this.items.length - 1;
    }
    this.index = index;
    this._cd.detectChanges();
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (!!changes["items"]) {
      //console.log(changes);
      if(!!changes["items"].previousValue && changes["items"].previousValue.length>0)
      {
        this.lastBackground = changes["items"].previousValue[this.index].image;
      }
      this.index = 0;
      this.autoTimer();
    }

  }
  timer = null;
  onThumbnailMouseEnter(index: number, event) {
    //this.dnSliderService.setIndex(index);
    this.stop = true;
    this.index = index;
    // 鼠标悬停Slider超长标题，文字跑马灯
    if (this.navigator === 'sidebar') {
      const navTextWidth = event.srcElement ? event.srcElement.children[0].offsetWidth : 0;
      const ifActive = event.srcElement.classList.contains('active');
      if (navTextWidth >= 183 && !ifActive) {
        event.srcElement.classList.add('marquee');
        clearTimeout(this.timer);
        this.timer = setTimeout(() => {
          const navTextHoverdWidth = event.srcElement.children[0].offsetWidth;
          event.srcElement.style.left = '-' + (navTextHoverdWidth - 264) + 'px';
        }, 250);
      }
    }
  }

  onThumbnailMouseLeave(event) {
    //this.dnSliderService.start();
    this.stop = false;
    if (event.srcElement) {
      event.srcElement.classList.remove('marquee');
      event.srcElement.style.left = 0;
    }
  }

  onIndicatorClick(index: number) {
    this.index = index;
    // this.dnSliderService.setIndex(index);
  }

  onSwipeLeft(index: number) {
    this.next();
    //  this.dnSliderService.next();
  }

  onSwipeRight(index: number) {
    this.previous();
    // this.dnSliderService.previous();
  }
}
